import _ from "lodash";
import {
  BYPASS_PRIVATE_DNS,
  BypassPrivateDns,
  ReportingServerData,
  Service,
  ServiceData,
  ServiceType,
} from "@sportal/api";

import { getSettings } from "../root.selectors";
import { PROFILES, SUPPORT } from "../../common/utils/permissions";
import { RootState } from "../root.reducer";

const getReporting = (state: RootState): ReportingServerData =>
  getSettings(state).reporting;

export const getSBSettingsService = (state: RootState): ServiceData => {
  const services = getSettings(state).services;

  return _.find(services, { service: Service.SecureBusiness });
};

export const isSBReportingLicensed = (state) => {
  return getReporting(state)[Service.SecureBusiness];
};

export const isMultipleSBSupported = (state) => {
  const service = getSBSettingsService(state);

  //@ts-ignore - fix SUPPORT keys
  return service && service[SUPPORT[Service.SecureBusiness][PROFILES.MULTIPLE]];
};

export const getSBServiceProfilesLimit = (state) => {
  const service = getSBSettingsService(state);

  return service && service["max-profiles"];
};

export const isBypassPrivateDNSFeatureEnabled = (state) => {
  const service = getSBSettingsService(state);

  return (
    service && service[BYPASS_PRIVATE_DNS][BypassPrivateDns.ApplePrivateRelay]
  );
};

export const isAllowListOverrideEnabled = (state) => {
  const service = getSBSettingsService(state);

  return (
    service &&
    _.includes(
      service["subscriber-allow-list-overrides"],
      ServiceType.InternetSecurity
    )
  );
};
